module.exports = "/_next/static/images/img_our_platform-0ca7015f503eaccad15a5d3393b79b8a.png";